// NOTE: this would format like 10.000,00 € -> blank space is removed
export const formatNumberCurrency = (number: number) =>
  new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })
    .format(number)
    .replace(/\s/g, '');

export const formatNumber = (number: number) =>
  new Intl.NumberFormat('de-DE').format(number);
